import Layout from "../views/layout/Layout";

export default {
    path: '',
    component: Layout,
    redirect: '/main',
    children: [{
        path: 'main',
        name: 'main',
        component: () => import('@/views/main/index'),
        meta: {title: '个人中心', icon: 'el-icon-user-solid'},
        auth: 'main'
    }]
}



// WEBPACK FOOTER //
// ./src/router/main.js